import React, { useState } from "react";
import { FileText } from "lucide-react";
import useUserStore from "../../store/useUserStore"
import "./TabHeader.css";

export const TabHeader = ({
  activeTab,
  setActiveTab,
  setShowLetterModal,
  letterType,
  isSurgical=false
}) => {
  
  const {isMobile}= useUserStore()

  return (
    <div className="tab-header">
      <div className="tab-buttons">
        <button
          className={`tab-button ${activeTab === "transcript" ? "active" : ""}`}
          onClick={() => setActiveTab("transcript")}
        >
          Transcript
        </button>
        {!isSurgical&&<button
          className={`tab-button ${activeTab === "summary" ? "active" : ""}`}
          onClick={() => setActiveTab("summary")}
        >
          Summary
        </button>}
        {isSurgical &&<button
          className={`tab-button ${activeTab === "surgical" ? "active" : ""}`}
          onClick={() => setActiveTab("surgical")}
        >
          Surgical Note
        </button>}
        {letterType && (
          <button
            className={`tab-button ${
              activeTab === `${letterType.toLowerCase()}-letter` ? "active" : ""
            }`}
            onClick={() => setActiveTab(`${letterType.toLowerCase()}-letter`)}
          >
            {letterType} Letter
          </button>
        )}
      </div>
      {!isSurgical&&<button
        className="generate-letter-btn"
        onClick={() => setShowLetterModal(true)}
      >
        <FileText size={18} />
        Generate letter
      </button>}
    </div>
  );
};
